module.exports = __webpack_public_path__ + "static/media/Papandopulijana mladih umjetnika 1.10a5360a.jpg";